// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  employeeLevels: [],
  employeeLevel: {},
}

export const mutations = {
  SET_EMPLOYEE_LEVELS(state, employeeLevels) {
    state.employeeLevels = employeeLevels
  },
  SET_EMPLOYEE_LEVEL(state, employeeLevel) {
    state.employeeLevel = employeeLevel
  },
  ADD_EMPLOYEE_LEVEL(state, employeeLevel) {
    state.employeeLevels.push(employeeLevel)
  },
  EDIT_EMPLOYEE_LEVEL(state, employeeLevel) {
    const index = state.employeeLevels.findIndex(
      (el) => el.employee_level_uuid === employeeLevel.employee_level_uuid
    )
    if (index !== -1) {
      state.employeeLevels.splice(index, 1, employeeLevel)
    }
  },
  DELETE_EMPLOYEE_LEVEL(state, employee_level_uuid) {
    const index = state.employeeLevels.findIndex(
      (el) => el.employee_level_uuid === employee_level_uuid
    )
    if (index !== -1) state.employeeLevels.splice(index, 1)
  },
}

export const actions = {
  fetchEmployeeLevels({ commit }, payload) {
    return ApiService.fetchEmployeeLevels(payload)
      .then((res) => {
        const employeeLevels = res.data.data
        commit('SET_EMPLOYEE_LEVELS', employeeLevels)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeeLevel({ commit, getters, state }, id) {
    if (state.employeeLevel.employee_level_id === id) {
      return state.employeeLevel
    }

    const employeeLevel = getters.getEmployeeLevelById(id)

    if (employeeLevel) {
      commit('SET_EMPLOYEE_LEVEL', employeeLevel)
      return employeeLevel
    } else {
      return ApiService.fetchEmployeeLevel(id)
        .then((res) => {
          const employeeLevel = res.data
          commit('SET_EMPLOYEE_LEVEL', employeeLevel)
          return employeeLevel
        })
        .catch((error) => {
          throw error
        })
    }
  },
  addEmployeeLevel({ commit }, payload) {
    return ApiService.addEmployeeLevel(payload)
      .then((res) => {
        const employeeLevel = res.data
        commit('ADD_EMPLOYEE_LEVEL', employeeLevel)
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployeeLevel({ commit }, payload) {
    return ApiService.editEmployeeLevel(payload)
      .then((res) => {
        const employeeLevel = res.data
        commit('EDIT_EMPLOYEE_LEVEL', employeeLevel)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeeLevel({ commit }, payload) {
    return ApiService.deleteEmployeeLevel(payload)
      .then(() => {
        commit('DELETE_EMPLOYEE_LEVEL', payload.employee_level_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {
  getEmployeeLevelById: (state) => (id) => {
    return state.employeeLevels.find((el) => el.employee_level_id === id)
  },
}
